import { APP_INITIALIZER, ApplicationConfig, ErrorHandler, provideBrowserGlobalErrorListeners, provideZoneChangeDetection, isDevMode } from '@angular/core';
import { provideRouter, Router } from '@angular/router';
import * as Sentry from "@sentry/angular";
import { createInterceptorCondition, INCLUDE_BEARER_TOKEN_INTERCEPTOR_CONFIG, IncludeBearerTokenCondition, includeBearerTokenInterceptor, provideKeycloak } from 'keycloak-angular';

import { routes } from './app.routes';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { environment } from '../environments/environment';
import { provideStore, provideState } from '@ngrx/store';
import { provideStoreDevtools } from '@ngrx/store-devtools';
import { GlobalErrorHandler } from './services/global-error-handler.service';

import { establishmentFeature } from './redux/reducers/establishment.reducers';
import { referenceDataFeature } from './redux/reducers/reference-data.reducers';
import { referenceFileFeature } from './redux/reducers/reference-file.reducers';
import { schoolOrganizationFeature } from './redux/reducers/school-organization.reducers';
import { courseGridFeature } from './redux/reducers/course-grid.reducers';
import { studentFeature } from './redux/reducers/student.reducers';
import { studentGridFeature } from './redux/reducers/student-grid.reducers';
import { uiFeature } from './redux/reducers/ui.reducers';
import { gridFeature } from './redux/reducers/grid.reducers'
import { profileFeature } from './redux/reducers/profile.reducers';
import { provideUiIcons } from './layout/icons.provider';

const urlCondition = createInterceptorCondition<IncludeBearerTokenCondition>({
  urlPattern: /\/api\//,
  bearerPrefix: 'Bearer'
});

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideKeycloak({
      config: environment.keycloak,
      initOptions: {
        onLoad: 'login-required',
        checkLoginIframe: false,
        pkceMethod: 'S256'
      }
    }),
    {
      provide: INCLUDE_BEARER_TOKEN_INTERCEPTOR_CONFIG,
      useValue: [urlCondition]
    },
    provideHttpClient(withInterceptors([includeBearerTokenInterceptor])),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),

    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    {
      provide: APP_INITIALIZER,
      useFactory: () => () => { },
      deps: [Sentry.TraceService],
      multi: true,
    },
    provideStore(),
    provideState(establishmentFeature),
    provideState(referenceDataFeature),
    provideState(referenceFileFeature),
    provideState(schoolOrganizationFeature),
    provideState(courseGridFeature),
    provideState(studentFeature),
    provideState(studentGridFeature),
    provideState(gridFeature),
    provideState(uiFeature),
    provideState(profileFeature),
    provideStoreDevtools({ maxAge: 25, logOnly: !isDevMode() }),
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
    provideUiIcons()
  ]
};
